class ComponentProductDifferentiators extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.cards = Array.from(this.querySelectorAll(".product-differentiators-card"));

    if (this.cards.length < 2) {
      return;
    }

    this.handheld = window.matchMedia("(max-width: 767px)");
    this.still = window.matchMedia("(prefers-reduced-motion: reduce)");

    this.index = Math.max(
      0,
      this.cards.findIndex((card) => card.classList.contains("state--active"))
    );

    this.interval = (Number(this.dataset.interval) || 3) * 1000;
    this.timer = null;
    this.settle = null;
    this.visible = false;

    this.activate(this.index);

    this.addDirectEvent("pointerover", this, (event) => this.hover(event));
    this.addDirectEvent("pointerleave", this, () => this.start());
    this.addDirectEvent("focusin", this, (event) => this.hover(event));
    this.addDirectEvent("focusout", this, () => this.start());
    this.addDirectEvent("change", this.handheld, () => this.sync());
    this.addDirectEvent("visibilitychange", document, () => {
      document.hidden ? this.stop() : this.start();
    });

    if (this.elements.track) {
      this.addDirectEvent("scroll", this.elements.track, () => this.track());
    }

    this.intersectionObserver((entry) => {
      this.visible = entry.isIntersecting;
      this.visible ? this.start() : this.stop();
    });

    this.sync();
  }

  sync() {
    this.handheld.matches ? this.stop() : this.start();
  }

  start() {
    this.stop();

    if (this.handheld.matches || this.still.matches || !this.visible || document.hidden) {
      return;
    }

    this.timer = window.setInterval(() => this.advance(), this.interval);
  }

  stop() {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  }

  advance() {
    this.activate((this.index + 1) % this.cards.length);
  }

  hover(event) {
    if (event.pointerType === "touch" || this.handheld.matches) {
      return;
    }

    const card = event.target.closest(".product-differentiators-card");
    const index = this.cards.indexOf(card);

    if (index === -1) {
      return;
    }

    this.stop();

    if (index !== this.index) {
      this.activate(index);
    }
  }

  track() {
    window.clearTimeout(this.settle);

    this.settle = window.setTimeout(() => {
      const index = this.nearest();

      if (index !== this.index) {
        this.activate(index);
      }
    }, 90);
  }

  nearest() {
    const track = this.elements.track;
    const middle = track.scrollLeft + track.clientWidth / 2;

    let closest = 0;
    let smallest = Infinity;

    this.cards.forEach((card, position) => {
      const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - middle);

      if (distance < smallest) {
        smallest = distance;
        closest = position;
      }
    });

    return closest;
  }

  activate(index) {
    this.index = index;

    this.cards.forEach((card, position) => {
      card.classList.toggle("state--active", position === index);
    });

    this.glow(this.cards[index]);
  }

  glow(card) {
    const surface = this.closest(".product-differentiators-glow");

    if (!surface) {
      return;
    }

    const color = getComputedStyle(card).getPropertyValue("--differentiator-glow").trim();

    surface.style.setProperty("--differentiator-glow-active", color || "transparent");
  }


  disconnectedCallback() {
    this.stop();
    window.clearTimeout(this.settle);

    super.disconnectedCallback();
  }
}

customElements.define("component-product-differentiators", ComponentProductDifferentiators);
